module.exports = __webpack_public_path__ + "static/media/location.047a40cd.svg";